module.exports = __webpack_public_path__ + "assets/xiangmuguanli.dc16ded8.svg";